import { RECEIVE_CONFIGURATION } from '../actions/taxConfig';

export default function configuration(state = {}, action) {
  switch (action.type) {
    case RECEIVE_CONFIGURATION:
      return action.configuration;
    default:
      return state;
  }
}
